import React, {Component} from 'react';
import {observer} from 'mobx-react';

import NewGroupSelect from './new_group_select/NewGroupSelect';
import GroupsSettingsComponent from './groups_settings/GroupsSettingsComponent';

@observer export default class ProductGroupsSettingsComponent extends Component {
	render() {
		/** @type {ProductGroupsSettingsContext} */
		const context = this.props.context;

		if (context.groups.length === 0) {
			return (
				<div>
					Добавьте новую группу <a target='_blank' href={`${context.backend_url}shop/?action=plugins#/productgroup`}>в настройках плагина</a>
				</div>
			);
		}

		return (
			<div className="fields">
				<NewGroupSelect context={context} />
				<GroupsSettingsComponent context={context} />
			</div>
		);
	}
}